import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import noop from '../../../../../utils/noop';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { DesktopDeviationSharePopup } from '../../../../../SharePopup';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import { getDeviationResourceType } from '../../../../_helpers';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import overlayStyles from '../../../../Helper/OverlayIcons.scss';
import s from './ShareControl.scss';
var offsetModifier = [0, 8];
var ShareControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, buttonClassName = _a.buttonClassName, iconClassName = _a.iconClassName, textClassName = _a.textClassName, _b = _a.showMobileSharePopup, showMobileSharePopup = _b === void 0 ? noop : _b;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _c = usePopoverOnInteraction({ listenOnClicks: true }), isVisible = _c.isVisible, popoverClick = _c.onClick, onClose = _c.onClose;
    var onClick = function () {
        if (isMobile) {
            showMobileSharePopup();
        }
        else {
            popoverClick();
        }
    };
    return (React.createElement(SimplePopperPopover, { isVisible: isVisible, popoverContent: React.createElement(DesktopDeviationSharePopup, { deviation: deviation }), onClickOutside: onClose, showArrow: false, offsetModifier: offsetModifier, className: className, contentClassName: s['popover'], usePortal: true },
        React.createElement(TextButton, { size: "medium", variant: "main", className: classnames(buttonClassName, overlayStyles['icon-button']), onClick: onClick, biData: BiData({
                evid: 355,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                deviationid: deviation.deviationId,
            }), "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON, "aria-label": t('deviationview.overlay.a11y.share') },
            React.createElement(ShareIcon, { size: IconSize.MEDIUM, withPadding: false, disableDefaultColors: true, className: classnames(overlayStyles['icon'], iconClassName) }),
            React.createElement("span", { className: textClassName }, t('actionbar.shareFromFeed')))));
};
ShareControl.displayName = 'ShareControl';
export default ShareControl;
//# sourceMappingURL=ShareControl.js.map